import BotIcon from '~/assets/images/Bot.png';
export const BOT_NAME = 'Andy';
export const BOT_ICON = BotIcon;
